import { render, staticRenderFns } from "./LoadingAnim.vue?vue&type=template&id=21c9313c&scoped=true"
import script from "./LoadingAnim.vue?vue&type=script&lang=js"
export * from "./LoadingAnim.vue?vue&type=script&lang=js"
import style0 from "./LoadingAnim.vue?vue&type=style&index=0&id=21c9313c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c9313c",
  null
  
)

export default component.exports